module.exports = __webpack_public_path__ + "static/media/acm3.8e5dae34.png";